import { Capacitor } from "@capacitor/core";

/**
 * True only inside the caloly iOS wrapper.
 *
 * MUST be Capacitor.isNativePlatform(), not a `window.Capacitor` presence
 * check: importing @capacitor/core anywhere in the bundle (purchases.ts
 * does) defines `window.Capacitor` in ordinary browsers too, and that
 * presence check once sent every caloly.com visitor to the app's login
 * screen instead of the landing page.
 */
export function isNativeApp(): boolean {
  if (Capacitor.isNativePlatform()) return true;
  // Dev-only escape hatch to verify native-only screens (Get Started,
  // Login) in a desktop browser. Gated on BOTH a localhost hostname and an
  // explicit window flag, so it can never evaluate true in production
  // (caloly.com, flag unset).
  if (
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) &&
    (window as unknown as { __CALOLY_FORCE_NATIVE__?: boolean }).__CALOLY_FORCE_NATIVE__ === true
  ) {
    return true;
  }
  return false;
}
